import { SealCheck, SealQuestion } from '@phosphor-icons/react';
import { Button, Loader, SignalButton, VText } from '@vake/ui-kit';
import { Feature } from 'geojson';
import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../auth/AuthProvider';
import { ManuallyValidateInput, useUpdateInsightLabels } from '../../../requests/insights';
import { useIsAdmin } from '../../../requests/reports';

type ValidateButtonProps = {
    onClick: (input: ManuallyValidateInput) => void;
};
const ManuallyValidateMatched = () => {
    return <></>;
};
const ManuallyValidateDarkVessel: FC<ValidateButtonProps> = ({ onClick }) => {
    return (
        <>
            <Button
                onClick={() => onClick({ matching_label: null, manually_validated: true })}
                text="It's a ship"
                iconAfter={<SealCheck />}
            />
            <SignalButton
                onClick={() => onClick({ matching_label: 'false_detection', manually_validated: true })}
                text="It's not a ship"
                iconAfter={<SealQuestion />}
            />
        </>
    );
};
const ManuallyValidateUndetected: FC<ValidateButtonProps> = ({ onClick }) => {
    return (
        <>
            <Button
                onClick={() => onClick({ matching_label: 'matched', manually_validated: true })}
                text="It's a ship"
                iconAfter={<SealCheck />}
            />
        </>
    );
};
type Props = {
    selectedFeature: Feature | null;
    date: Date;
};
type RouteParams = {
    reportUuid: string;
};
export const ManuallyValidate: FC<Props> = ({ selectedFeature, date }) => {
    const params = useParams<RouteParams>();
    const { token } = useAuth();
    const { data: isAdmin } = useIsAdmin(token);
    const { mutateAsync, isLoading, isSuccess, isError, reset } = useUpdateInsightLabels(date, params.reportUuid);
    useEffect(() => {
        if (isSuccess) {
            setTimeout(() => {
                reset();
            }, 2000);
        }
    }, [isSuccess, reset]);
    if (!isAdmin) {
        return <></>;
    }
    if (!selectedFeature || !selectedFeature.properties) {
        return <></>;
    }
    if (selectedFeature.properties.manually_validated) {
        return <></>;
    }
    if (isError) {
        return <VText>Something went wrong</VText>;
    }
    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center">
                <Loader size={24} />
            </div>
        );
    }
    if (isSuccess) {
        return <VText>Thank you for updating the insight</VText>;
    }
    const handleOnClick = async (input: ManuallyValidateInput) => {
        const uuid = selectedFeature.properties?.uuid;
        await mutateAsync({ ...input, uuid });
    };
    if (selectedFeature.properties.matching_label === 'matched') {
        return <ManuallyValidateMatched />;
    }
    if (selectedFeature.properties.matching_label === 'dark_vessel') {
        return <ManuallyValidateDarkVessel onClick={handleOnClick} />;
    }
    if (selectedFeature.properties.matching_label === 'undetected') {
        return <ManuallyValidateUndetected onClick={handleOnClick} />;
    }
    return <></>;
};
